import { DecisionEngineStatus } from "@hightouch/lib/customer-data/decision-engine/types";

import { Flows } from "./types";

export function isActiveAgent(
  agent: Pick<Flows[number], "enabled" | "status" | "config">,
) {
  return (
    (agent.enabled && agent.status === DecisionEngineStatus.READY) ||
    agent.config.demo_data
  );
}

export function isOnsiteFlow(flow: Pick<Flows[number], "flow_type">): boolean {
  return flow.flow_type === "onsite";
}
